import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'

// Pages
import Home from './pages/Home'
import About from './pages/About'
import Renovation from './pages/Renovation'
import NewBuild from './pages/NewBuild'
import Porebeton from './pages/Porebeton'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'
import Forbidden from './pages/Forbidden'

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-warm-gray-50 text-anthracite antialiased">
      {/* Scroll restoration */}
      <ScrollToTop />

      {/* Navigation Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/renovering" element={<Renovation />} />
          <Route path="/nybyg" element={<NewBuild />} />
          <Route path="/porebeton" element={<Porebeton />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}
